import * as React from 'react';

// components
import Input from '../shared/Input';
import { NavLink } from 'react-router-dom';
import { Button, Alert } from 'reactstrap';

import { Form, Field } from 'react-final-form';

// networking
import AxiosHelper from 'services/AxiosHelper';
import * as axios from 'axios';
import { AxiosError, AxiosResponse } from 'axios';

// types
import { LoginResponse } from './types';
import Spinner from 'components/shared/Spinner';
import { handleAxiosErrorWithValidation } from 'util/Misc';

import createDecorator from 'final-form-focus';
import SimpleCheckBox from '../shared/SimpleCheckBox';
const focusOnErrors = createDecorator();

/**
 * LoginTwoFactor component
 *
 * @class LoginTwoFactor
 * @extends {React.PureComponent<any>}
 */
class LoginTwoFactor extends React.PureComponent<any> {
	private cancelToken: any = null;

	public componentWillUnmount() {
		if (this.cancelToken) {
			this.cancelToken();
		}
	}

	public submit = (formValues: any): Promise<void | unknown> => {
		if (this.cancelToken) {
			this.cancelToken();
		}

		const url = `/ajax/login-two-factor/`;

		const searchParams = new URLSearchParams(this.props.location ? this.props.location.search : '');
		const redirectUrl = searchParams.get('ReturnUrl');

		return AxiosHelper.post(url, formValues, {
			cancelToken: new axios.default.CancelToken((token) => {
				this.cancelToken = token;
			}),
		})
			.then((response: AxiosResponse<LoginResponse>) => {
				if (response.data.success) {
					window.location.href = redirectUrl ? redirectUrl : '/';
				} else {
					window.location.href = response.data.redirectUrl;
				}
			})
			.catch((error: AxiosError) => {
				return handleAxiosErrorWithValidation(error, null);
			})
			.then((promise: any) => {
				this.cancelToken = null;
				return promise;
			});
	};

	public render() {
		return (
			<div className="login-form">
				<div>
					<h2 className="login-form-heading">
						Your login is protected with an authenticator app. Enter your authenticator code below.
					</h2>
				</div>

				<Form
					onSubmit={this.submit}
					decorators={[focusOnErrors]}
					subscription={{ submitting: true, submitError: true }}
					render={({ handleSubmit, submitError, submitting }) => (
						<form onSubmit={handleSubmit} className="login-form">
							{submitError ? (
								<div>
									<Alert color="danger">{submitError}</Alert>
								</div>
							) : null}

							<Field
								name="twoFactorCode"
								label="Authenticator code"
								type="text"
								autoFocus
								className="login-form__row login-form__text-input"
								component={Input}
							/>

							<div className="text-center login-form-heading">
								<Field
									name="rememberThisBrowser"
									label="Remember this browser"
									type="checkbox"
									component={SimpleCheckBox}
								/>
							</div>

							<div className="login-form__actions form-group">
								<Button
									type="submit"
									disabled={submitting}
									color="primary"
									data-testid="submit-2fa-login-btn"
									className="login-form__action login-form__submit-btn"
								>
									Login
								</Button>
							</div>

							<div className="login-form__actions form-group">
								<p className="text-center login-form-heading">
									Don&apos;t have access to your authenticator device? <br />
									You can
									<NavLink
										className="login-form__action login-form__link"
										exact
										activeClassName="active"
										to="/account/login-recovery"
										data-testid="login-recovery-link"
									>
										{' '}
										log in with a recovery code
									</NavLink>
								</p>
							</div>
							<div className="login-form__actions form-group">{submitting ? <Spinner /> : null}</div>
						</form>
					)}
				/>
			</div>
		);
	}
}

export default LoginTwoFactor;
